<template>
  <div class="hmi-piloto">
    <div class="outer-circle">
      <div class="inner-circle" :style="innerStyle"></div>
    </div>
    <div class="label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "HmiPiloto",
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "green",
    },
    isOn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerStyle() {
      return {
        backgroundColor: this.isOn ? this.color : "transparent",
      };
    },
  },
};
</script>

<style scoped>
.hmi-piloto {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.outer-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inner-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.label {
  margin-top: 5px;
}
</style>
